import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { ResidentialComponent } from './residential.component';
import { SharedModule } from '../shared';
import { ResidentialFormComponent } from './residential-form/residential-form.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NewCarrierRatesComponent } from './new-carrier-rates/new-carrier-rates.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import { NewCarrierRatesOptionComponent } from './new-carrier-rates-option/new-carrier-rates-option.component';
import { CommunityDetailsFormComponent } from './community-details-form/community-details-form.component';
import { ResidentialPaymentComponent } from './residential-payment/residential-payment.component';
import { ResidentialInsuredDetailsComponent } from './residential-insured-details/residential-insured-details.component';
import { MatButtonModule } from '@angular/material/button';
import { PmDetailsFormComponent } from './pm-details-form/pm-details-form.component';
import { ResidentialCommunitySelectorComponent } from './residential-form/residential-community-selector/residential-community-selector.component';
import { ResidentialFormBuildingsSelectComponent } from './residential-form/residential-form-buildings-select/residential-form-buildings-select.component';
import { UIModule } from '../ui/ui.module';
import { PaperlessAgreementComponent } from './residential-form/paperless-agreement/paperless-agreement.component';

const routers: Routes = [
    {
      path: '',
      component: ResidentialComponent
    },
    {
      path: ':id',
      component: ResidentialComponent
    }
];

@NgModule({
  declarations: [
    ResidentialComponent,
    ResidentialFormComponent,
    NewCarrierRatesComponent,
    CommunityDetailsFormComponent,
    NewCarrierRatesOptionComponent,
    ResidentialPaymentComponent,
    ResidentialInsuredDetailsComponent,
    PmDetailsFormComponent,
    ResidentialCommunitySelectorComponent,
    ResidentialFormBuildingsSelectComponent,
    PaperlessAgreementComponent
  ],
  imports: [
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    GooglePlaceModule,
    RouterModule.forChild(routers),
    UIModule
  ]
})
export class ResidentialModule { }
